import script from "./PatientList.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientList.vue?vue&type=script&setup=true&lang=js"

import "./PatientList.vue?vue&type=style&index=0&id=e795f100&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e795f100"]])

export default __exports__